

export default class BaseObject
{
    key:string;
    constructor(key:string)
    {
        this.key = key;
    }
}